import React from 'react';
import {
   Image,
   ImageBackground,
   Text,
   View,
   StyleSheet,
   Dimensions,
   StatusBar,
   TouchableOpacity,
   Platform,
} from 'react-native';
import {
   drawerListBackgroundColor,
   drawerHeaderGradientStartColor,
   drawerHeaderGradientEndColor,
   FONT_FAMILY_REGULAR,
   getProfileImage,
} from '../../utils/utils';
import DashboardMenuList from './DashboardMenuList';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import logger from '../../utils/logger';
const {width, height} = Dimensions.get('window');

const listViewDataSoure = [
   {
      id: '1',
      title: 'Dashboard',
      icon: require('../../assets/dashboard.png'),
   },
   {
      id: '2',
      title: 'My Training',
      icon: require('../../assets/bookmark_training.png'),
   },
   {
      id: '3',
      title: 'Browse Courses',
      icon: require('../../assets/browse_courses.png'),
   },
   {
      id: '4',
      title: 'Logout',
      icon: require('../../assets/logout_white.png'),
   },
];

const Header = props => (
   <View style={styles.headerContainer}>
      <View
         style={[
            styles.logoContainer,
            {
               height: (height - height * 0.65) * 0.25,
               width: width * 0.75,
               ...Platform.select({
                  web: {
                     width: '100%',
                     height: 56,
                  },
               }),
            },
         ]}>
         <Image
            source={require('../../assets/my_logo_header.png')}
            style={styles.foregroundImage}
         />
         <View
            style={{
               flex: 1,
            }}
         />
         <TouchableOpacity
            onPress={() => {
               props.onMenuClick();
            }}>
            <Image
               style={styles.crossicon}
               source={require('../../assets/cross.png')}
            />
         </TouchableOpacity>
         <View />
      </View>

      {/*This section is being used for profile section*/}
      <TouchableOpacity
         onPress={() => {
            logger('menu pressed');
            props.openProfileScreen();
         }}>
         <View
            style={[
               styles.profile,
               {
                  height: (height - height * 0.65) * 0.25,
                  width: width * 0.75,
                  ...Platform.select({
                     web: {
                        width: '100%',
                        height: 56,
                     },
                  }),
               },
            ]}>
            <View
               style={{
                  flexDirection: 'row',
                  width: '90%',
               }}>
               <Image
                  source={
                     props.profileImage === 'NoPic'
                        ? require('../../assets/p_default.png')
                        : {
                             uri: `${props.profileImage}`,
                          }
                  }
                  style={styles.profileImage}
               />
               <Text
                  numberOfLines={2}
                  ellipsizeMode="tail"
                  style={[
                     styles.userName,
                     {
                        //maxWidth: 200,
                        ...Platform.select({
                           web: {
                              wordBreak: 'break-all',
                           },
                        }),
                     },
                  ]}>
                  {'Welcome \n'}
                  {props.userName}
               </Text>
            </View>

            <View
               style={{
                  width: '10%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingRight: 15,
               }}>
               <Image
                  source={require('../../assets/arrowWhite.png')}
                  style={[styles.arrowIcon]}
               />
            </View>
         </View>
      </TouchableOpacity>
   </View>
);

const Item = ({icon, title, iconTintColor, titleColor, isSelected, id}) => (
   <View style={styles.item}>
      <View style={{flexDirection: 'row'}}>
         <Image
            style={[styles.icon, {tintColor: iconTintColor}]}
            source={icon}
         />
         <Text style={[styles.title, {color: titleColor}]}>{title}</Text>
      </View>

      {isSelected ? (
         <View style={{flex: 1}}>
            <Image
               source={require('../../assets/rectangle.png')}
               style={[styles.rectanglebar, {maxHeight: 56}]}
            />
         </View>
      ) : null}
   </View>
);

const onMenuSelect = id => {
   logger('pressed' + id);
};

const DashboardLeftView = props => (
   <View style={styles.container}>
      <ImageBackground
         style={[
            styles.backgroundImage,
            {height: Platform.OS === 'web' ? '100vh' : '100%'},
         ]}
         source={require('../../assets/dashboard_leftPanel.png')}>
         {/*This SVG section is for providing the gradient effect on image*/}

         <DashboardMenuList
            ItemSeparatorComponent={props => {
               // here you can access the trailingItem with props.trailingItem
               return (
                  <View
                     style={{
                        height: 10,
                        ...Platform.select({
                           web: {
                              backgroundColor: 'transparent',
                           },
                        }),
                     }}
                  />
               );
            }}
            ListHeaderComponent={
               <Header
                  onMenuClick={props.onMenuClick}
                  userName={props.userName}
                  profileImage={props.profileImage}
                  openProfileScreen={props.openProfileScreen}
               />
            }
            data={listViewDataSoure}
            renderItem={({item, iconTintColor, titleColor, isSelected}) => (
               <Item
                  icon={item.icon}
                  title={item.title}
                  iconTintColor={iconTintColor}
                  titleColor={titleColor}
                  isSelected={isSelected}
                  id={item.id}
               />
            )}
            keyExtractor={item => item.id}
            onSelect={item => {
               logger('pressed' + item.id);
               props.onRowSelected(item.id);
            }}
         />
         <Image
            source={require('../../assets/norcat-logo_white.png')}
            style={[styles.bottomlogo, {tintColor: 'white', opacity: 0.4}]}
         />
      </ImageBackground>
   </View>
);

const styles = StyleSheet.create({
   container: {
      flex: 1,
      height: height - height * 0.65,
      //backgroundColor: drawerListBackgroundColor,
      shadowColor: 'black',
      shadowOffset: {width: width * 0.25 * 0.2, height: 0},
      shadowOpacity: 0.1,
      shadowRadius: 5,
      elevation: 5, // for Android
   },
   profile: {
      backgroundColor: '#003DA5',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
   },
   profileImage: {
      width: 40,
      height: 40,
      marginLeft: 16,
      borderRadius: 20,
      alignSelf: 'center',
   },
   arrowIcon: {
      margin: 10,
      width: 24,
      height: 24,
   },
   userName: {
      fontSize: 14,
      marginHorizontal: 16,
      color: 'white',
      alignSelf: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      maxWidth: 160,
   },
   logoImage: {
      height: 118,
      width: 64,
      alignContent: 'center',
   },
   item: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginVertical: 8,
      marginHorizontal: 16,
      height: 30,
   },
   icon: {
      width: 20,
      height: 20,
      marginRight: 16,
   },
   rectanglebar: {
      width: 4,
      height: 40,
      marginLeft: 'auto',
      marginRight: -15,
   },
   crossicon: {
      width: 18,
      height: 18,
   },
   title: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '500',
   },
   backgroundImage: {
      flex: 1,
      resizeMode: 'cover',
   },
   headerContainer: {
      flex: 1,
      marginTop: '12%',
   },
   foregroundImage: {
      width: 40,
      height: 40,
   },
   logoContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 16,
   },
   bottomlogo: {
      width: 135,
      height: 18,
      tintColor: 'gray',
      alignSelf: 'center',
      marginBottom: 30,
   },
});

export default DashboardLeftView;
